module.exports = "/_next/static/images/bf963aa24bcea6c9501e41633bd1efd3-vigilado-superfn.png";